import type { RouterOutputs } from "~/utils/trpc";

export type DeckType = NonNullable<RouterOutputs["deck"]["getById"]>;
export type DeckFeatureType = NonNullable<RouterOutputs["deck"]["getById"]>["feature"];
export type DeckPreviewType = RouterOutputs["deck"]["search"]["decks"][0];
export type DecklistType = RouterOutputs["deck"]["getDecklistById"];
export type DeckCardType = NonNullable<RouterOutputs["deck"]["getDecklistById"]>[0];
export type DeckCommentType = NonNullable<RouterOutputs["deck"]["getCommentsById"]>[0];

export enum DeckModeEnum {
  VIEW = "view",
  EDIT = "edit",
  SETTINGS = "settings",
  PRIMER = "primer",
}

export enum DeckSortEnum {
  LATEST = "latest",
  NAME = "name",
  TRENDING = "trending",
  ALLTIME = "all time",
}

export enum DeckDividerEnum {
  ALL = "all",
  MINE = "mine",
  FOLLOWING = "following",
  LIKED = "liked",
}

export const DECK_SORT_DEFAULT = DeckSortEnum.LATEST;
